import { useGameState } from './hooks/useGameState';
import { useViewportMetrics } from './hooks/useViewportMetrics';
import GameHeader from './components/GameHeader';
import GuideScreen from './components/GuideScreen';
import PracticeScreen from './components/PracticeScreen';
import GameScreen from './components/GameScreen';
import ResultScreen from './components/ResultScreen';
import ExitConfirmModal from './components/ExitConfirmModal';
import {
  PRACTICE1_CONFIG,
  PRACTICE2_CONFIG,
  STAGE1_CONFIG,
  STAGE2_CONFIG,
  STAGE3_CONFIG,
} from './tmtConfig';

export default function TmtPage() {
  const metrics = useViewportMetrics();
  const {
    screen,
    showExitModal,
    path,
    wrongId,
    completed,
    transitionMsg,
    elapsedMs,
    score,
    totalTimeMs,
    totalWrongCount,
    goToPractice,
    handleSelect,
    openExitModal,
    closeExitModal,
    confirmExit,
    goToNext,
  } = useGameState();

  const showHeader = screen === 'guide';

  return (
    <div
      className="tmt-scope w-full bg-secondary-100 flex justify-center overflow-hidden"
      style={{ height: `${metrics.height}px` }}
    >
      <div className="w-full max-w-[430px] h-full bg-secondary-100 flex flex-col overflow-hidden relative game-no-scroll">
        {showHeader && <GameHeader screen={screen} onClose={openExitModal} />}

        <div className="flex-1 overflow-hidden">
          {screen === 'guide' && <GuideScreen onStart={goToPractice} />}
          {screen === 'practice1' && (
            <PracticeScreen
              config={PRACTICE1_CONFIG}
              path={path}
              wrongId={wrongId}
              completed={completed}
              onSelect={handleSelect}
              onClose={openExitModal}
            />
          )}
          {screen === 'practice2' && (
            <PracticeScreen
              config={PRACTICE2_CONFIG}
              path={path}
              wrongId={wrongId}
              completed={completed}
              onSelect={handleSelect}
              onClose={openExitModal}
            />
          )}
          {screen === 'stage1' && (
            <GameScreen
              config={STAGE1_CONFIG}
              path={path}
              wrongId={wrongId}
              completed={completed}
              elapsedMs={elapsedMs}
              transitionMsg={transitionMsg}
              onSelect={handleSelect}
              onClose={openExitModal}
            />
          )}
          {screen === 'stage2' && (
            <GameScreen
              config={STAGE2_CONFIG}
              path={path}
              wrongId={wrongId}
              completed={completed}
              elapsedMs={elapsedMs}
              transitionMsg={transitionMsg}
              onSelect={handleSelect}
              onClose={openExitModal}
            />
          )}
          {screen === 'stage3' && (
            <GameScreen
              config={STAGE3_CONFIG}
              path={path}
              wrongId={wrongId}
              completed={completed}
              elapsedMs={elapsedMs}
              transitionMsg={transitionMsg}
              onSelect={handleSelect}
              onClose={openExitModal}
            />
          )}
          {screen === 'result' && (
            <ResultScreen
              score={score}
              totalTimeMs={totalTimeMs}
              wrongCount={totalWrongCount}
              onRetry={goToPractice}
              onNext={goToNext}
            />
          )}
        </div>

        <ExitConfirmModal
          isOpen={showExitModal}
          onConfirm={confirmExit}
          onCancel={closeExitModal}
        />
      </div>
    </div>
  );
}